<button
    [type]="type"
    class="custom-btn"
    [ngClass]="'btn--' + variant"
    [disabled]="disabled"
    [title]="title || ''"
>
    <span class="material-icons btn-icon" *ngIf="icon" aria-hidden="true">{{ icon }}</span>
    <span class="btn-label" *ngIf="label">{{ label }}</span>
    <ng-content></ng-content>
</button>
